import { ComponentType } from "react"
import { DateRange } from "react-day-picker"
import { FieldValues } from "react-hook-form"
import { z } from "zod"

import { IStepInfo } from "@/components/features/form/FormPage.tsx"

export type TStep<T extends FieldValues = FieldValues> = {
  Step: ComponentType
  fields?: readonly (keyof T)[]
  isIgnored?: (formValues: T) => boolean
  stepInfo?: IStepInfo
  onNextClick?: (fieldValues: Partial<T>) => unknown
}

export const zYear = (min: number = 0) =>
  z.coerce
    .number({ message: "Required" })
    .min(min, `Year must be ${min} or later`)
    .max(new Date().getFullYear(), `Year cannot be in the future`)

export const zNumber = z.number({ coerce: true, message: "Required" }).min(0)

export const zInputSquare = z
  .union([z.array(z.any(), { message: "Required" }), z.null(), z.undefined()])
  .transform((value) => (typeof value === "string" ? [value] : value))
  .refine((value) => value !== undefined && !(Array.isArray(value) && value.length === 0), { message: "Required" })

export const zDate = z.custom<DateRange>(
  (val: DateRange) => {
    return val && val.to && val.from
  },
  { message: "Required" },
)

export function toUTCMidnight(date: Date): string {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  return new Date(Date.UTC(year, month, day)).toISOString()
}
